<template>
    <div>
        <span v-if="limit" :class="{ 'text-danger': textLength > limit }">
            {{ prefix }}{{ $filters.format_number(textLength) }} / {{ $filters.format_number(limit) }}{{ suffix }}
        </span>
        <span v-else>{{ prefix }}{{ $filters.format_number(textLength) }}{{ suffix }}</span>
    </div>
</template>

<script>
export default {
    name: 'CharacterCount',

    props: ['text', 'limit', 'prefix', 'suffix'],

    computed: {
        textLength() {
            return String(this.text).length;
        },
    }
}
</script>
